export enum CustomGraphType {
    gauge = 'Gauge', 
    meter = 'Meter', 
    indicator = 'Indicator' 
};

export const customGraphSize = {
    [CustomGraphType.gauge] : {
        width: 340,
        height: 340
    },
    [CustomGraphType.meter] : {
        width: 162,
        height: 340
    },
    [CustomGraphType.indicator] : {
        width: 162,
        height: 162
    },
}